import { api } from '../services/api';

const HCL_ROOT = 'perubahan_kepemilikan_idx/hcl/';

function buildBlobUrl(path: string, containerUrl: string, sasToken: string): string {
  const isDev = (import.meta as any).env?.DEV || false;
  return isDev
    ? `/azure-blob-proxy/trading-data-v2/${path}?${sasToken}`
    : `${containerUrl}/${path}?${sasToken}`;
}

function parseCSVLine(text: string): string[] {
  let inQuotes = false;
  let currentVal = '';
  const result: string[] = [];
  
  for (let i = 0; i < text.length; i++) {
    const char = text[i];
    
    if (char === '"' && text[i + 1] === '"') {
      currentVal += '"';
      i++;
    } else if (char === '"') {
      inQuotes = !inQuotes;
    } else if (char === ',' && !inQuotes) {
      result.push(currentVal.trim());
      currentVal = '';
    } else {
      currentVal += char;
    }
  }
  result.push(currentVal.trim());
  return result;
}

export async function fetchHCLData(): Promise<{ data: any[] }> {
  try {
    const tokenRes = await api.getStockMetadataSasToken();
    if (!tokenRes.success || !tokenRes.data) throw new Error(tokenRes.error || 'Failed to get SAS token');
    
    const { containerUrl, sasToken } = tokenRes.data;
    const blobName = `${HCL_ROOT}hcl.csv`;
    const url = buildBlobUrl(blobName, containerUrl, sasToken);
    
    const res = await fetch(url);
    if (!res.ok) {
      if (res.status === 404) return { data: [] };
      throw new Error(`HTTP error! status: ${res.status}`);
    }
    
    const text = await res.text();
    const lines = text.split(/\r?\n/).filter(line => line.trim() !== '');
    if (lines.length < 2) return { data: [] };
    
    const headers = parseCSVLine(lines[0]);
    const data = [];
    
    for (let i = 1; i < lines.length; i++) {
      const values = parseCSVLine(lines[i]);
      const row: any = {};
      
      headers.forEach((header, index) => {
        let val = values[index];
        if (val) {
          // Remove extra quotes if present
          if (val.startsWith('"') && val.endsWith('"')) {
            val = val.slice(1, -1);
          }
          row[header.trim()] = val;
        }
      });
      
      if (Object.keys(row).length > 0) {
        data.push(row);
      }
    }
    
    return { data };
  } catch (error) {
    console.error('Error fetching HCL data:', error);
    return { data: [] };
  }
}
